import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// A higer order component that sets a handler for a click outside the component
// More details on the higher order componet (HOC) pattern here: https://reactjs.org/docs/higher-order-components.html
// Wrapped components should implement `onClickOutside`
// Click outside behaviour taken from: https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
const withClickOutside = (WrappedComponent) => class extends Component {

  constructor(props) {
    super(props);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.setWrappedRef = this.setWrappedRef.bind(this);
  }

  // Add a click handler on mount, and remove it on unmount
  componentDidMount() {
    document.addEventListener('mousedown', this.handlePageClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handlePageClick);
  }

  // Create a reference to wrapped component
  // and also to the wrapped components dom node
  setWrappedRef(component) {
    // the ref will be the wrapped component itself, not it's dom node
    this.wrappedComponent = component;
    // NOTE that although findDOMNode is discouraged except in special cases, this is one of those cases
    // it is the only way to get a ref to the wrapped components dom node
    // https://reactjs.org/docs/react-dom.html#finddomnode
    // MM: then we need to mark it as an exception to the linter rule
    // https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
    /* eslint react/no-find-dom-node: 0 */
    this.wrappedDomRef = ReactDOM.findDOMNode(component);
  }

  // Handle a page click event
  // If the click was outside the component, run onClickOutside method
  // on the wrapped component
  // otherwise do nothing
  handlePageClick(event) {
    // do nothing if we have clicked inside the div
    if (this.wrappedDomRef && this.wrappedDomRef.contains(event.target)) { return; }
    // call the onClickOutside method implemented by the wrapped component
    this.wrappedComponent.onClickOutside();
  }

  render() {
    return (
      <WrappedComponent
        ref={this.setWrappedRef}
        /* This is a higher order component... We want to pass in all the props and we don't always know what those props are! */
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...this.props}
      />
    );
  }

};


export { withClickOutside };
